import script from "./AIChatQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./AIChatQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./AIChatQuestion.vue?vue&type=style&index=0&id=aa8a3bfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa8a3bfe"]])

export default __exports__